// removed by extract-text-webpack-plugin
module.exports = {"ImageContainer":"Image__ImageContainer___svIcL","ImageContainerIE":"Image__ImageContainerIE___1p3h3","ImageContainerContain":"Image__ImageContainerContain___3iPNP","ImageContainerLoading":"Image__ImageContainerLoading___1qaUK","ImageContainerLight":"Image__ImageContainerLight___S3Q1H","ImageContainerDark":"Image__ImageContainerDark___2BI2-","LoadingLayer":"Image__LoadingLayer___1Zgxl","LoadingIcon":"Image__LoadingIcon___1_gJp"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/Image/Image.less
// module id = 1153
// module chunks = 0 1